export const mathRound = value => Math.round(value * 100) / 100

export const toFixed = (value, digitCount = 2) =>
  // eslint-disable-next-line no-restricted-globals
  isNaN(Number(value)) ? value : value.toFixed(digitCount)

export const roundToTens = value => Math.round(value / 10) * 10

export const isInt = number => number % 1 === 0

export const getFormattedNum = number =>
  new Intl.NumberFormat('en').format(number)

/**
 * @param value - the value to be rounded
 * @param factor - the number of decimal places by which the value is rounded
 * @param divider - the number of decimal places that the output value should have (default is factor)
 * @returns {number}
 */
export const roundTo = (value, factor, divider) => {
  if (divider === undefined) {
    // eslint-disable-next-line no-param-reassign
    divider = factor
  }

  /* eslint-disable no-param-reassign */
  factor = 10 ** factor
  divider = 10 ** divider
  /* eslint-enable no-param-reassign */

  return Math.round(value * factor) / divider
}
